module.exports = __webpack_public_path__ + "static/media/bingo.16f6c723.mp4";